export const formatDocument = (value: string): string => {
  value = value.slice(0, 18);
  value = value.replace(/\D/g, "");

  if (value.length <= 11) {
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  } else {
    value = value.replace(/^(\d{2})(\d)/, "$1.$2");
    value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
    value = value.replace(/(\d{4})(\d)/, "$1-$2");
  }

  return value;
};

export const formatPhone = (value: string) => {
  const cleanedValue = value.replace(/\D/g, "");

  const formattedValue = cleanedValue.replace(
    /(\d{2})(\d{5})(\d{4})/,
    "($1)$2-$3"
  );

  return formattedValue;
};

export const maskDocument = (value: string): string => {
  const cleanedValue = value.replace(/\D/g, "");

  if (cleanedValue.length === 11) {
    return `***.***.${cleanedValue.slice(6, 9)}-${cleanedValue.slice(9)}`;
  } else if (cleanedValue.length === 14) {
    return `**.***.${cleanedValue.slice(5, 8)}/${cleanedValue.slice(8, 12)}-${cleanedValue.slice(12)}`;
  } else {
    return value;
  }
};





